module.exports = __webpack_public_path__ + "static/CloudBattery-2-light-c92e1eb8eeaab0f06c1c5189e4f1a0f3.svg";